"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MigrateController", {
    enumerable: true,
    get: function() {
        return MigrateController;
    }
});
const _common = require("@nestjs/common");
const _migrateservice = require("src/modules/jobs/jobs/export-import/migrate.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _basesservice = require("~/services/bases.service");
const _models = require("~/models");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _ncError = require("~/helpers/ncError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let MigrateController = class MigrateController {
    async migrateBase(context, baseId, req, body) {
        const base = await _models.Base.get(context, baseId);
        if (!base) {
            _ncError.NcError.get(context).baseNotFound(baseId);
        }
        const source = (await base.getSources())[0];
        if (!source) {
            _ncError.NcError.get(context).noSourcesFound();
        }
        const url = new URL(body.migrationUrl);
        const instanceUrl = url.origin;
        // secret query param
        const secret = url.searchParams.get('secret');
        if (!instanceUrl || !secret) {
            _ncError.NcError.get(context).badRequest('Invalid migration url');
        }
        return await this.migrateService.migrateBase({
            context,
            base,
            source,
            secret: secret,
            instanceUrl: instanceUrl,
            req
        });
    }
    constructor(jobsService, basesService, migrateService){
        this.jobsService = jobsService;
        this.basesService = basesService;
        this.migrateService = migrateService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/meta/migrate/:baseId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('migrateBase'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], MigrateController.prototype, "migrateBase", null);
MigrateController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService,
        typeof _migrateservice.MigrateService === "undefined" ? Object : _migrateservice.MigrateService
    ])
], MigrateController);
